import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface Message<T> {
    action: string;
    payload?: T;
}

export type Queues<T> = Record<string, Subject<Message<T> | null>>;

@Injectable({
    providedIn: 'root',
})
export class MessagingService {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private queues: Queues<any> = {};

    /***
     * @param topic
     * @param subject$$ (BehaviorSubject, ReplaySubject, AsyncSubject)
     *
     *  this.messagingService.subscription(topic).pipe(
     *     tap(msg => console.log(msg)),
     *     untilDestroyed(this),
     *  ).subscribe()
     *
     */

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    subscription(topic: string, subject$$: Subject<Message<any> | null> | null = null): Observable<Message<any> | null> {
        if (!this.queues[topic]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.queues[topic] = subject$$ || new Subject<Message<any>>();
        }
        return this.queues[topic].asObservable();
    }

    /***
     *
     * @param topic
     * @param message
     *
     *  this.messagingService.publish(topic, message);
     */

    publish<T>(topic: string, message: Message<T>) {
        if (!this.queues[topic]) {
            throw new Error(`Topic "${topic}" does not exist.`);
        }
        this.queues[topic].next(message);
    }

    publishTo<T>(topics: string[], message: Message<T>) {
        topics.forEach(topic => this.queues[topic].next(message));
    }

    publishAll<T>(message: Message<T>) {
        Object.keys(this.queues).forEach(topic => this.queues[topic].next(message));
    }

    clear(topic: string) {
        delete this.queues[topic];
    }

    clearAll() {
        Object.keys(this.queues).forEach(topic => delete this.queues[topic]);
    }
}
